var map = {
	"./background-branch-detail.svg": "0091",
	"./background-customer.svg": "57f0",
	"./background-document-detail.svg": "f5fe",
	"./background-document.svg": "f300",
	"./background-fl-detail.svg": "448c",
	"./background-panel-hello--dark.svg": "62b8",
	"./background-panel-hello-max.svg": "5541",
	"./background-panel-hello.svg": "07fd",
	"./background-pos-detail.svg": "c739",
	"./background-supplier.svg": "d68b",
	"./modal-aceptar-rechazar.svg": "14dc",
	"./modal-branch.svg": "f7fa",
	"./modal-cl-accept.svg": "ae20",
	"./modal-cl-claim.svg": "7d55",
	"./modal-document-clone.svg": "71f4",
	"./modal-document-confirm.svg": "5199",
	"./modal-document-create-fl.svg": "d2e7",
	"./modal-document-create-success.svg": "b9cc",
	"./modal-document-error-fl.svg": "24a9",
	"./modal-document-null.svg": "6b39",
	"./modal-el-lock.svg": "b241",
	"./modal-export-fl.svg": "7787",
	"./modal-folios-upload.svg": "d604",
	"./modal-member.svg": "9586",
	"./modal-mode.svg": "0efe",
	"./modal-numbering.svg": "466e",
	"./modal-purchase-null.svg": "c1ae",
	"./modal-segment-destroy.svg": "9919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f26c";